import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";

export default function ZamboniScanAll() {
  const navigate = useNavigate();
  const [running, setRunning] = useState(false);
  const [message, setMessage] = useState("");
  const [jobId, setJobId] = useState(null);
  const [ensureMin, setEnsureMin] = useState(3);
  const [batchSize, setBatchSize] = useState(5);
  const [maxRetries, setMaxRetries] = useState(3);

  const trigger = async () => {
    setRunning(true);
    setMessage("Triggering Zamboni scan...");
    setJobId(null);
    try {
      const {
        data: { session },
        error: sessionErr,
      } = await supabase.auth.getSession();
      if (sessionErr) throw sessionErr;
      const token = session?.access_token;
      if (!token) throw new Error("Not authenticated");

      const { data, error } = await supabase.functions.invoke(
        "zamboni_check_dialogs_assets",
        {
          body: {
            ensure_dialogs_at_least: Number(ensureMin),
            batch_size: Number(batchSize),
            max_retries: Number(maxRetries),
            trigger_processing: true,
          },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (error) throw error;
      setJobId(data?.job_id || null);
      setMessage(data?.message || "Scan-all job created.");
    } catch (err) {
      console.error(err);
      setMessage(err.message || "Failed to trigger Zamboni scan.");
    } finally {
      setRunning(false);
    }
  };

  return (
    <div className="min-h-screen w-full bg-base-100 flex flex-col">
      <header className="bg-primary text-white py-6 shadow-md flex-shrink-0">
        <div className="container mx-auto px-4 flex items-center">
          <button onClick={() => navigate("/admin")} className="flex items-center text-white mr-6">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
          </button>
          <h1 className="text-3xl font-bold flex-1 text-center">Zamboni Scan (All Words)</h1>
          <div className="w-[76px]"></div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8 max-w-xl">
        <div className="bg-white p-6 rounded-lg shadow-md space-y-4">
          <div className="grid grid-cols-3 gap-3">
            <label className="form-control">
              <div className="label"><span className="label-text">Min dialogs</span></div>
              <input type="number" className="input input-bordered" min={1} max={10} value={ensureMin} onChange={(e) => setEnsureMin(e.target.value)} />
            </label>
            <label className="form-control">
              <div className="label"><span className="label-text">Batch size</span></div>
              <input type="number" className="input input-bordered" min={1} max={50} value={batchSize} onChange={(e) => setBatchSize(e.target.value)} />
            </label>
            <label className="form-control">
              <div className="label"><span className="label-text">Max retries</span></div>
              <input type="number" className="input input-bordered" min={0} max={10} value={maxRetries} onChange={(e) => setMaxRetries(e.target.value)} />
            </label>
          </div>

          <button className="btn btn-primary w-full" onClick={trigger} disabled={running}>
            {running ? "Starting…" : "Run Zamboni Scan"}
          </button>

          {message && (
            <div className="p-3 bg-gray-50 rounded-lg text-sm">
              {message}
              {jobId && (
                <div className="mt-1 font-mono break-all">job_id: {jobId}</div>
              )}
            </div>
          )}

          <div className="p-4 bg-gray-50 rounded-lg text-sm text-gray-600">
            This triggers a scan-all job that enqueues every word in pages and then processes them in batches to avoid timeouts.
          </div>
        </div>
      </main>
    </div>
  );
}
